/**
 * 客服任务处理
 */
import React, { useState, useEffect } from "react";
import {
  Card,
  Form,
  Row,
  Col,
  Button,
  message,
  Input,
  Popover,
  Modal,
  Select,
  Tag,
  Popconfirm,
  Tooltip,
  Table,
  Collapse,
  Image,
} from "antd";
import dayjs from "dayjs";
import CommonTable from "@/components/commonTable";
import ExportButton from "@/components/exportButton";
import DatePicker from "@/components/datePicker";
import RenderEllipsisColumn from "@/components/renderEllipsisColumn";
import { useTable } from "@/utils/useTable";
import styles from "@/styles/pageContent.module.scss";
import PermissionButton from "@/components/permissionButton";
// import OperateModalTask from './components/operateModal';
import {
  serviceTaskListRequestPath,
  serviceTaskListRequest,
  DeleteServiceTask,
  batchAssignServiceTask,
  dispatchAgentTask,
} from "@/service/serviceTask";
import OperateService from "@/pages/carDiagnosis/components/operateService";
import OperateModal from "../workOrder/components/operateModal"; //操作工单
import { upsertServiceTask } from "@/service/serviceTask";
import { userListRequest } from "@/service/userManage";
import { useDispatch, useSelector } from "react-redux";
import TaskDetail from "../serviceTask/components/taskDetail";
import HistoryResult from "./components/historyResult";
import AllServiceRecord from "./components/allServiceRecord";
import Thumbnail from "@/components/thumbnail";
import SendBackCause from "./components/sendBackCause";
import { tagListRequest } from "@/service/tagManage";
import { TagCategoryEnum } from "@/constants/tagManage";
import { insureListRequest } from "@/service/insurerManage";
import { cccAgentOptionsRequest } from "@/service/smartCustomerServiceNumber";
import { deviceTypeData } from "@/constants/deviceManage";
import type { TableRowSelection } from "antd/es/table/interface";

const { RangePicker } = DatePicker;

const ServiceTaskDispose = () => {
  const tabPagesStore = useSelector((state: any) => state.tabPagesStore);
  const { activeKey, tabParams } = tabPagesStore;
  const dispatch = useDispatch();
  const [searchParams, setSearchParams] = useState({}); // 搜索相关的参数
  const [operateInfo, setOperateInfo] = useState<any>({}); // 表格操作的信息
  const [addWorkOrder, setAddWorkOrder] = useState<any>({}); // 创建工单的弹窗
  const [operateVisible, setOperateVisible] = useState<any>({}); // 添加客服记录的弹窗
  const [serveTypeList, setServeTypeList] = useState<any>([]); // 问题来源的标签
  const [userData, setUserData] = useState<any>([]); // 客服人员数据
  const [insurerList, setInsurerList] = useState<any>([]); // 保司列表
  const [batchAssignVisible, setBatchAssignVisible] = useState(false); // 批量分配客服弹窗
  const [batchAssignLoading, setBatchAssignLoading] = useState(false); // 批量分配提交loading
  const [batchAssignCustomerId, setBatchAssignCustomerId] = useState<number | undefined>(undefined); // 选中的客服人员id
  const [form] = Form.useForm();
  const { page, limit, loading, data, totalCount, onPageChange, getData } =
    useTable({
      requestFunc: serviceTaskListRequest,
      initPageSize: 40,
      searchParams,
    });
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]); // 表格选择的项
  const [agentTaskPool, setAgentTaskPool] = useState<any[]>([]); // 智能体任务池
  const [agentTaskPoolVisible, setAgentTaskPoolVisible] = useState(false); // 智能体任务池折叠
  const [dispatchAgentVisible, setDispatchAgentVisible] = useState(false); // 派发智能体任务弹窗
  const [dispatchAgentLoading, setDispatchAgentLoading] = useState(false); // 派发智能体任务提交loading
  const [agentOptions, setAgentOptions] = useState<any[]>([]); // 智能体列表
  const [dispatchAgentId, setDispatchAgentId] = useState<number | undefined>(undefined); // 选中的智能体id(aiAgentId)

  // 编辑的时候赋值
  useEffect(() => {
    getServeType();
    getUserData();
    getInsurerList();
  }, []);

  // 获取客服人员数据
  const getUserData = async () => {
    const res = await userListRequest({ page: 1, limit: 9999 });
    setUserData(res.data?.data || []);
  };

  // 获取保司列表
  const getInsurerList = async () => {
    const res = await insureListRequest('');
    const tags: any = [];
    (res.data?.data || []).forEach((item: any) => {
      const { name } = item;
      tags.push({ label: name, value: name });
    });
    setInsurerList(tags);
  };

  // 监听跳转时携带参数的形式
  useEffect(() => {
    tabParamsSearch();
  }, [activeKey, tabParams]);

  // 跳转时携带参数时搜索
  const tabParamsSearch = async () => {
    if (tabParams) {
      const newTabParams = {
        plateNumber: tabParams.plateNumber,
      };
      // form.setFieldsValue(newTabParams);
      form.submit();
      const detailItem = {
        plateNumber: tabParams.obj,
      };
      //弹出评论的框
      // setOperateInfo({ type: 'detail', data: detailItem })
    }
  };

  // 处理搜索参数
  const operateSearchParams = (params: any, isExport?: boolean) => {
    const newSearchParams: any = { ...params };
    if (params.time) {
      newSearchParams.beginDate = dayjs(params.time[0]).format("YYYY-MM-DD");
      newSearchParams.endDate = dayjs(params.time[1]).format("YYYY-MM-DD");
      delete newSearchParams.time;
    }
    if (params.disTime) {
      newSearchParams.dealBeginDate = dayjs(params.disTime[0]).format(
        "YYYY-MM-DD"
      );
      newSearchParams.dealEndDate = dayjs(params.disTime[1]).format(
        "YYYY-MM-DD"
      );
      delete newSearchParams.disTime;
    }
    if (params.expectTime) {
      newSearchParams.expectBeginDate = dayjs(params.expectTime[0]).format(
        "YYYY-MM-DD"
      );
      newSearchParams.expectEndDate = dayjs(params.expectTime[1]).format(
        "YYYY-MM-DD"
      );
      delete newSearchParams.expectTime;
    }
    if (typeof newSearchParams.commonPhone === "string") {
      newSearchParams.commonPhone = newSearchParams.commonPhone.trim();
    }
    if (newSearchParams.commonPhone === "") {
      delete newSearchParams.commonPhone;
    }
    if (isExport) {
      newSearchParams.export = true;
    }
    return newSearchParams;
  };

  // 搜索
  const onSearch = async (values: any) => {
    const newSearchParams = operateSearchParams(values);
    setSearchParams(newSearchParams); //搜索相关参数
  };

  // 获取导出的参数
  const getExportParams = () => {
    const values = form.getFieldsValue();
    return operateSearchParams(values, true);
  };

  // 任务状态
  const stateData = [
    { label: "未处理", value: 0 },
    { label: "待处理-客服", value: 1 },
    { label: "智能体-已呼叫", value: 2 },
     { label: "派工单", value: 3 },
    { label: "处理中-已派工单", value: 4 },
    { label: "处理中-已完成现场处理", value: 5 },
    { label: "处理完成", value: 6 },
    { label: "已退回", value: 7 },
    { label: "已关闭", value: 8 },
    { label: "智能体-待处理", value: 9 },
    { label: "待处理-对接市场", value: 10 },
    { label: "无法配合", value: 11 },
    { label: "待处理", value: 12 },
    { label: "卖车", value: 13 },
  ];

  // 获取问题来源
  const getServeType = async () => {
    const res = await tagListRequest({
      tagSorts: [TagCategoryEnum.serveType],
    });
    const tags: any = [];
    (res.data?.data || []).forEach((item: any) => {
      const { title } = item;
      tags.push({ label: title, value: title });
    });
    setServeTypeList(tags);
  };

  // 点击车牌跳转车辆诊断
  const skipCarDiagnosis = (value: any) => {
    dispatch({
      type: "addTab",
      payload: {
        tab: "车辆诊断",
        key: "/car-admin/car-diagnosis",
        params: {
          plateNumber: value,
          beginDate: dayjs().subtract(7, "day").format("YYYY-MM-DD"),
          endDate: dayjs().subtract(1, "day").format("YYYY-MM-DD"),
        },
      },
    });
    getData();
  };

  // 删除单条
  const deleteCarInterviewItem = async (id: number) => {
    const res = await DeleteServiceTask(id);
    if (res.data?.code === 0) {
      message.success("删除成功");
      getData();
    }
  };

  // 接受任务
  const confireItem = async (item: any) => {
    const params = { ...item };
    params.taskState = 1;
    const res = await upsertServiceTask(params);
    if (res.data?.code === 0) {
      message.success("修改成功");
      getData();
    }
  };

  // // 拒绝任务
  // const refuseItem = async(item: any) => {
  //   const params = {...item}
  //   params.taskState = 7
  //   const res = await upsertServiceTask(params);
  //   if (res.data?.code === 0) {
  //     message.success('修改成功');
  //     getData();
  //   }
  // }

  // 客服记录回调
  const anyData = async (one: any, two: any) => {
    const params = one;
    params.taskState = two.treatmentStateType;
    params.expectedTime = two.expectedTime
      ? dayjs(two.expectedTime).format("YYYY-MM-DD HH:mm:ss")
      : undefined;
    const res = await upsertServiceTask(params);
   
    if (two.treatmentStateType == 3) {
      const paramsss = { ...one };
      paramsss.category = two.category; // 问题来源
      paramsss.types = two.types; // 问题原因
      paramsss.reason = two.reason; // 问题原因(自定义)
      paramsss.contactIdentity = two.contactIdentity; // 联系人身份
      paramsss.contactName = two.contactName; //  联系人姓名
      paramsss.tel = two.tel; // 联系人电话
       paramsss.content = two.content; //  客户记录内容
      setAddWorkOrder({ type: "servicrTaskAdd", data: paramsss });
    }
    getData();
  };

  // 创建工单
  const getWorkOrderId = async (
    orderId: any,
    customerId: any,
    anyData: any
  ) => {
    const params = anyData;
    params.orderId = orderId;
    params.taskState = 3;
    const res = await upsertServiceTask(params);
    getData();
  };

  // 关闭评论
  const taskCommentDetail = () => {
    setOperateInfo({});
    getData();
  };

  //处理完成
  const finishedWork = async (item: any) => {
    const params = { ...item };
    params.taskState = 6;
    const res = await upsertServiceTask(params);
    if (res.data?.code === 0) {
      message.success("修改成功");
      getData();
    }
  };

  const onSelectChange = (newSelectedRowKeys: React.Key[]) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const rowSelection: TableRowSelection<any> = {
    selectedRowKeys,
    onChange: onSelectChange,
    selections: [
      Table.SELECTION_ALL,
      Table.SELECTION_INVERT,
      Table.SELECTION_NONE,
    ],
  };

  //批量添加客服记录
  const addserviceRecodeBatch = () => {
    setOperateVisible({
      show: true,
      type: "serviceTaskBatchAdd",
      data: selectedRowKeys,
    });
  };

  //批量派发工单
  const distributeBatch = () => {
    const aaa: any = [];
    selectedRowKeys.map((item: any) => {
      data.map((items: any) => {
        console.log("items", items);
        if (item == items.id) {
          aaa.push(items);
        }
      });
    });
    setAddWorkOrder({
      show: true,
      type: "servicBatchDispatchOrder",
      data: aaa,
    });
  };

  // 批量分配客服 - 打开弹窗
  const handleBatchAssign = () => {
    if (selectedRowKeys.length === 0) {
      message.warning("请先勾选需要分配的任务");
      return;
    }
    setBatchAssignCustomerId(undefined);
    setBatchAssignVisible(true);
  };

  // 批量分配客服 - 提交
  const handleBatchAssignSubmit = async () => {
    if (!batchAssignCustomerId) {
      message.warning("请选择客服人员");
      return;
    }
    setBatchAssignLoading(true);
    try {
      const res = await batchAssignServiceTask({
        assignCustomerId: batchAssignCustomerId,
        ids: selectedRowKeys as number[],
      });
      if (res.data?.code === 0) {
        message.success("分配成功");
        setBatchAssignVisible(false);
        setSelectedRowKeys([]);
        getData();
      }
    } finally {
      setBatchAssignLoading(false);
    }
  };

  // 添加至智能体任务池
  const handleAddToAgentTask = () => {
    if (selectedRowKeys.length === 0) {
      message.warning("请先勾选需要添加的任务");
      return;
    }
    const selectedData = data.filter((item: any) =>
      selectedRowKeys.includes(item.id)
    );
    setAgentTaskPool((prev) => {
      const newPool = [...prev];
      selectedData.forEach((item: any) => {
        const exists = newPool.some((poolItem) => poolItem.id === item.id);
        if (!exists) {
          newPool.push(item);
        }
      });
      return newPool;
    });
    message.success("添加成功");
    setAgentTaskPoolVisible(true);
  };

  // 从智能体任务池移除
  const handleRemoveFromAgentTask = (id: number) => {
    setAgentTaskPool((prev) => prev.filter((item) => item.id !== id));
  };

  // 打开派发智能体任务弹窗
  const openDispatchAgentModal = async () => {
    if (agentTaskPool.length === 0) {
      message.warning("智能体任务池为空，请先添加任务");
      return;
    }
    setDispatchAgentId(undefined);
    setDispatchAgentVisible(true);
    getAgentOptions();
  };

  // 获取智能体列表
  const getAgentOptions = async () => {
    try {
      const res = await cccAgentOptionsRequest();
      setAgentOptions(res.data?.data || []);
    } catch (error) {
      setAgentOptions([]);
    }
  };

  // 派发智能体任务 - 提交
  const handleDispatchAgentTask = async () => {
    if (dispatchAgentId === undefined || dispatchAgentId === null) {
      message.warning("请选择智能体");
      return;
    }
    setDispatchAgentLoading(true);
    try {
      const customerTaskIds = agentTaskPool.map((item) => item.id);
      const res = await dispatchAgentTask({
        customerTaskIds,
        agentId: dispatchAgentId,
      });
      if (res.data?.code === 0) {
        if (res.data.data?.success) {
          message.success("派发成功");
          setAgentTaskPool([]);
          setAgentTaskPoolVisible(false);
          setDispatchAgentVisible(false);
        } else {
          message.error(res.data.data?.errorMessage || "派发失败");
        }
      } else {
        message.error(res.data?.msg || "派发失败");
      }
    } catch (error) {
      message.error("派发失败");
    } finally {
      setDispatchAgentLoading(false);
    }
  };

  // 表格列显示
  const columns = [
    {
      title: "序号",
      dataIndex: "id",
      width: 50,
      ellipsis: { showTitle: false },
    },
    {
      title: "车牌号",
      dataIndex: "plateNumber",
      width: 110,
      ellipsis: { showTitle: false },
      // 王美丽新增 悬浮车牌号显示离线天数
      render: (value: string, item: any) => (
        <div
          style={{ color: "#1890ff", cursor: "pointer" }}
          onClick={() => skipCarDiagnosis(value)}
        >
          <Tooltip placement="topLeft" title={item.onlineState}>
            {value}
          </Tooltip>
        </div>
      ),
    },
    {
      title: "设备类型",
      dataIndex: "deviceTypeStr",
      width: 120,
      ellipsis: { showTitle: false },
      render: (value: string) => <RenderEllipsisColumn text={value} />,
    },
    {
      title: "任务类型",
      dataIndex: "type",
      width: 100,
    },
    {
      title: "分配客服",
      dataIndex: "assignCustomer",
      width: 130,
      ellipsis: { showTitle: false },
    },
    {
      title: "处理方式",
      dataIndex: "dealType",
      width: 100,
      ellipsis: { showTitle: false },
      render: (value: any) => {
        if (value === 0) return "人工";
        if (value === 1) return "智能";
        return value;
      },
    },
    // {
    //   title: "沟通类型",
    //   dataIndex: "classify",
    //   width: 130,
    //   ellipsis: { showTitle: false },
    // },
    {
      title: "任务状态",
      dataIndex: "taskState",
      width: 180,
      ellipsis: { showTitle: false },
      render: (value: any) => {
        const matched = stateData.find((item) => item.value == value);
        return matched ? <Tag>{matched.label}</Tag> : null;
      },
    },
    {
      title: "adas在线状态",
      dataIndex: "adasOnlineState",
      width: 200,
      ellipsis: { showTitle: false },
      render: (value: string) => <RenderEllipsisColumn text={value} />,
    },
    {
      title: "aeb在线状态",
      dataIndex: "aebOnlineState",
      width: 200,
      ellipsis: { showTitle: false },
      render: (value: string) => <RenderEllipsisColumn text={value} />,
    },
    {
      title: "主问题",
      dataIndex: "masterProblem",
      width: 200,
      ellipsis: { showTitle: false },
      render: (value: string) => <RenderEllipsisColumn text={value} />,
    },
    {
      title: "次问题",
      dataIndex: "slaveProblem",
      width: 200,
      ellipsis: { showTitle: false },
      render: (value: string) => <RenderEllipsisColumn text={value} />,
    },
    {
      title: "DMS图片",
      dataIndex: "dmsPicUrl",
      width: 110,
      render: (value: string) =>
        value ? <Image src={value} alt="DMS图片" width="100%" /> : null,
    },
    {
      title: "ADAS图片",
      dataIndex: "adasPicUrl",
      width: 110,
      render: (value: string) =>
        value ? <Image src={value} alt="ADAS图片" width="100%" /> : null,
    },
    {
      title: "BSD图片",
      dataIndex: "bsdPicUrl",
      width: 110,
      render: (value: string) =>
        value ? <Image src={value} alt="BSD图片" width="100%" /> : null,
    },
    {
      title: "车辆情况说明",
      dataIndex: "ex",
      width: 200,
      ellipsis: { showTitle: false },
      render: (value: string) => <RenderEllipsisColumn text={value} />,
    },
    {
      title: "负责人",
      dataIndex: "linkman",
      width: 130,
      ellipsis: { showTitle: false },
    },
    {
      title: "负责人电话",
      dataIndex: "tel",
      width: 130,
      ellipsis: { showTitle: false },
    },
    {
      title: "司机",
      dataIndex: "carDriver",
      width: 130,
      ellipsis: { showTitle: false },
    },
    {
      title: "司机电话",
      dataIndex: "carDriverPhone",
      width: 130,
      ellipsis: { showTitle: false },
    },
    {
      title: "车队长",
      dataIndex: "carPrincipal",
      width: 130,
      ellipsis: { showTitle: false },
    },
    {
      title: "车队长电话",
      dataIndex: "carPrincipalPhone",
      width: 130,
      ellipsis: { showTitle: false },
    },
    {
      title: "渠道",
      dataIndex: "channel",
      width: 150,
      ellipsis: { showTitle: false },
      render: (value: string) => <RenderEllipsisColumn text={value} />,
    },
    {
      title: "所属公司",
      dataIndex: "company",
      width: 150,
      ellipsis: { showTitle: false },
      render: (value: string) => <RenderEllipsisColumn text={value} />,
    },
    {
      title: "车辆地址",
      dataIndex: "district",
      width: 130,
      ellipsis: { showTitle: false },
      render: (value: string) => <RenderEllipsisColumn text={value} />,
    },
    {
      title: "车架号",
      dataIndex: "frameNumber",
      width: 100,
      ellipsis: { showTitle: false },
      render: (value: string) => <RenderEllipsisColumn text={value} />,
    },
    {
      title: "保司",
      dataIndex: "insurer",
      width: 150,
      ellipsis: { showTitle: false },
      render: (value: string) => <RenderEllipsisColumn text={value} />,
    },

    {
      title: "影像",
      dataIndex: "resourceViewDtos",
      width: 170,
      ellipsis: { showTitle: false },
      render: (value: any) => (
        <Thumbnail
          dataSource={value || []}
          downloadImgName="图片"
          downloadVideoName="视频"
        />
      ),
    },
    {
      title: "备注",
      dataIndex: "remark",
      width: 200,
      ellipsis: { showTitle: false },
      render: (value: string) => <RenderEllipsisColumn text={value} />,
    },
    {
      title: "任务创建人",
      dataIndex: "creator",
      width: 130,
      ellipsis: { showTitle: false },
    },
    {
      title: "创建时间",
      dataIndex: "createdAt",
      width: 170,
      ellipsis: { showTitle: false },
      render: (value: string) =>
        value ? dayjs(value).format("YYYY-MM-DD HH:mm:ss") : value,
    },
    {
      title: "客服处理人",
      dataIndex: "dealCustomer",
      width: 130,
      ellipsis: { showTitle: false },
    },
    {
      title: "处理时间",
      dataIndex: "beginDealTime",
      width: 170,
      ellipsis: { showTitle: false },
      render: (value: string) =>
        value ? dayjs(value).format("YYYY-MM-DD HH:mm:ss") : value,
    },
    {
      title: "期望完成时间",
      dataIndex: "expectedTime",
      width: 170,
      ellipsis: { showTitle: false },
      render: (value: string) =>
        value ? dayjs(value).format("YYYY-MM-DD HH:mm:ss") : value,
    },
    {
      title: "操作",
      dataIndex: "operate",
      width: 240,
      fixed: "right" as "right",
      render: (value: any, item: any) => {
        return (
          <div className={styles.tableOperateColumn}>
            <>
              <PermissionButton
                operateType="/car-admin/car-diagnosis/service-recoed-all"
                type="link"
                onClick={() => setOperateInfo({ type: "record", data: item })}
              >
                客服记录
              </PermissionButton>
              {/* <PermissionButton
                  operateType="/car-admin/car-diagnosis/service-recoed-add"
                  type="link"
                  onClick={() =>
                    setOperateVisible({
                      show: true,
                      type: "serviceTaskDisposeAdd",
                      data: item,
                    })
                  }
                >
                  新增客服记录
                </PermissionButton> */}
            </>
            {/* <Popconfirm
              title="您确定要删除该任务吗?"
              onConfirm={() => deleteCarInterviewItem(item.id)}
            >
              <PermissionButton operateType='/car-admin/service-task/delete' type="link">删除</PermissionButton>
            </Popconfirm> */}
            {/* {item?.onePersonFlag == 0 ? <div>
              <PermissionButton operateType='/car-admin/car-diagnosis/service-recoed-all'  type="link" onClick={() => setOperateInfo({ type: 'record', data: item })}>客服记录</PermissionButton>
            </div> : null} */}
            {item.taskState == 0 ? (
              <>
                <PermissionButton
                  operateType="/car-admin/service-task-dispose/comment"
                  type="link"
                  onClick={() => setOperateInfo({ type: "detail", data: item })}
                >
                  评论
                </PermissionButton>
                <Popconfirm
                  title="您确定要接收此任务吗?"
                  onConfirm={() => confireItem(item)}
                >
                  <PermissionButton
                    operateType="/car-admin/service-task-dispose/confire"
                    type="link"
                  >
                    接收任务
                  </PermissionButton>
                </Popconfirm>
                {/* <Popconfirm
                title="您确定要拒绝此任务吗?
                onConfirm={() => refuseItem(item)}>
                <PermissionButton operateType='/car-admin/service-task-dispose/refuse' type="link">拒绝任务</PermissionButton>
              </Popconfirm> */}
                <PermissionButton
                  operateType="/car-admin/service-task-dispose/refuse"
                  type="link"
                  onClick={() =>
                    setOperateInfo({
                      type: "sendback",
                      data: item,
                    })
                  }
                >
                  拒绝任务
                </PermissionButton>
              </>
            ) : item.taskState == 1 ? (
              <>
                <PermissionButton
                  operateType="/car-admin/service-task-dispose/comment"
                  type="link"
                  onClick={() => setOperateInfo({ type: "detail", data: item })}
                >
                  评论
                </PermissionButton>
                <PermissionButton
                  operateType="/car-admin/car-diagnosis/service-recoed-add"
                  type="link"
                  onClick={() =>
                    setOperateVisible({
                      show: true,
                      type: "serviceTaskDisposeAdd",
                      data: item,
                    })
                  }
                >
                  新增客服记录
                </PermissionButton>
              </>
            ) : item.taskState == 10 ? (
              <>
                <PermissionButton
                  operateType="/car-admin/service-task-dispose/comment"
                  type="link"
                  onClick={() => setOperateInfo({ type: "detail", data: item })}
                >
                  评论
                </PermissionButton>
                <PermissionButton
                  operateType="/car-admin/car-diagnosis/service-recoed-add"
                  type="link"
                  onClick={() =>
                    setOperateVisible({
                      show: true,
                      type: "serviceTaskDisposeAdd",
                      data: item,
                    })
                  }
                >
                  新增客服记录
                </PermissionButton>
                <PermissionButton
                  operateType="/car-admin/car-diagnosis/service-recoed-edit"
                  type="link"
                  onClick={() =>
                    setOperateVisible({
                      show: true,
                      type: "serviceTaskDisposeEdit",
                      data: item,
                    })
                  }
                >
                  编辑上条客服记录
                </PermissionButton>
                {/* <PermissionButton
                  operateType="/car-admin/car-diagnosis/service-recoed-history"
                  type="link"
                  onClick={() =>
                    setOperateInfo({
                      type: "history",
                      data: item,
                    })
                  }
                >
                  历史联系结果
                </PermissionButton> */}
              </>
            ) : item.taskState == 9 || item.taskState == 12 ? (
              <>
                <PermissionButton
                  operateType="/car-admin/service-task-dispose/comment"
                  type="link"
                  onClick={() => setOperateInfo({ type: "detail", data: item })}
                >
                  评论
                </PermissionButton>
                <PermissionButton
                  operateType="/car-admin/car-diagnosis/service-recoed-add"
                  type="link"
                  onClick={() =>
                    setOperateVisible({
                      show: true,
                      type: "serviceTaskDisposeAdd",
                      data: item,
                    })
                  }
                >
                  新增客服记录
                </PermissionButton>
                <PermissionButton
                  operateType="/car-admin/car-diagnosis/service-recoed-edit"
                  type="link"
                  onClick={() =>
                    setOperateVisible({
                      show: true,
                      type: "serviceTaskDisposeEdit",
                      data: item,
                    })
                  }
                >
                  编辑上条客服记录
                </PermissionButton>
                {/* <PermissionButton
                  operateType="/car-admin/car-diagnosis/service-recoed-history"
                  type="link"
                  onClick={() =>
                    setOperateInfo({
                      type: "history",
                      data: item,
                    })
                  }
                >
                  历史联系结果
                </PermissionButton> */}
              </>
            ) : item.taskState == 2 ? (
              <>
                <PermissionButton
                  operateType="/car-admin/service-task-dispose/comment"
                  type="link"
                  onClick={() => setOperateInfo({ type: "detail", data: item })}
                >
                  评论
                </PermissionButton>
                <PermissionButton
                  operateType="/car-admin/service-task-dispose/orderId"
                  type="link"
                  onClick={() =>
                    setAddWorkOrder({
                      type: "servicrTaskAdd",
                      data: item,
                    })
                  }
                >
                  派工单
                </PermissionButton>
                 <PermissionButton
                  operateType="/car-admin/car-diagnosis/service-recoed-add"
                  type="link"
                  onClick={() =>
                    setOperateVisible({
                      show: true,
                      type: "serviceTaskDisposeAdd",
                      data: item,
                    })
                  }
                >
                  新增客服记录
                </PermissionButton>
                <Popconfirm
                  title="确认是否处理完成?"
                  onConfirm={() => finishedWork(item)}
                >
                  <PermissionButton
                    operateType="/car-admin/service-task-dispose/finished"
                    type="link"
                  >
                    处理完成
                  </PermissionButton>
                </Popconfirm>
              </>
            ) : (
              <PermissionButton
                operateType="/car-admin/service-task-dispose/comment"
                type="link"
                onClick={() =>
                  setOperateInfo({
                    type: "detail",
                    data: item,
                  })
                }
              >
                评论
              </PermissionButton>
            )}
          </div>
        );
      },
    },
  ];

  return (
    <Card bordered={false} className={styles.fixPageContentBox}>
      <Collapse defaultActiveKey={"column"}>
        <Collapse.Panel header="搜索参数" key="column">
          <Form
            onFinish={onSearch}
            form={form}
            autoComplete="off"
            layout="vertical"
          >
            <Row gutter={24}>
              <Col span={6}>
                <Form.Item label="创建日期" name="time">
                  <RangePicker allowClear={true} style={{ width: "100%" }} />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item label="客服处理日期" name="disTime">
                  <RangePicker allowClear={true} style={{ width: "100%" }} />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item label="车牌号" name="plateNumber">
                  <Input
                    placeholder="请输入车牌号"
                    allowClear
                    onChange={(e) => {
                      const newV = e.target.value.replace(/\s+/g, "");
                      form.setFieldValue("plateNumber", newV);
                    }}
                  />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item label="车架号" name="frameNumber">
                  <Input
                    placeholder="请输入车架号"
                    allowClear
                    onChange={(e) => {
                      const newV = e.target.value.replace(/\s+/g, "");
                      form.setFieldValue("frameNumber", newV);
                    }}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={24}>
              <Col span={4}>
                <Form.Item label="所属公司" name="company">
                  <Input placeholder="请输入所属公司" allowClear />
                </Form.Item>
              </Col>
              <Col span={5}>
                <Form.Item label="渠道" name="channel">
                  <Input placeholder="请输入渠道" allowClear />
                </Form.Item>
              </Col>
              <Col span={5}>
                <Form.Item label="联系人电话" name="commonPhone">
                  <Input placeholder="请输入联系人电话" allowClear />
                </Form.Item>
              </Col>
              <Col span={5}>
                {/* 王美丽新增 需确认字段名称name */}
                <Form.Item label="任务状态" name="state">
                  <Select
                    options={stateData}
                    placeholder="请选择任务状态"
                    showSearch
                    mode="multiple"
                    showArrow
                    maxTagCount="responsive"
                  />
                </Form.Item>
              </Col>
              <Col span={5}>
                <Form.Item label="任务类型" name="type">
                  <Select
                    options={serveTypeList}
                    placeholder="请选择任务类型"
                    showSearch
                    mode="multiple"
                    showArrow
                    maxTagCount="responsive"
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={24}>
              <Col span={4}>
                <Form.Item label="分配客服" name="assignCustomer">
                  <Input placeholder="请输入分配客服" allowClear />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item label="期望完成日期" name="expectTime">
                  <RangePicker allowClear={true} style={{ width: "100%" }} />
                </Form.Item>
              </Col>
              <Col span={5}>
                <Form.Item label="主问题" name="masterProblem">
                  <Input placeholder="请输入主问题" allowClear />
                </Form.Item>
              </Col>
              <Col span={5}>
                <Form.Item label="保司" name="insurer">
                  <Select
                    options={insurerList}
                    placeholder="请选择保司"
                    allowClear
                    showArrow
                    showSearch
                    optionFilterProp="label"
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={24}>
              <Col span={5}>
                <Form.Item label="设备类型" name="deviceType">
                  <Select
                    options={deviceTypeData}
                    placeholder="请选择设备类型"
                    allowClear
                    showArrow
                    showSearch
                    optionFilterProp="label"
                  />
                </Form.Item>
              </Col>
              <Col span={5}>
                <Form.Item label="客服处理方式" name="dealType">
                  <Select
                    options={[
                      { label: '人工', value: 0 },
                      { label: '智能', value: 1 }
                    ]}
                    placeholder="请选择处理方式"
                    allowClear
                    showArrow
                    showSearch
                  />
                </Form.Item>
              </Col>
              <Col span={10}>
                <Form.Item>
                  <div
                    className={styles.searchBox}
                    style={{ marginTop: "32px" }}
                  >
                    <Button type="primary" htmlType="submit">
                      搜索
                    </Button>
                    <ExportButton
                      url={serviceTaskListRequestPath}
                      fileName="客服任务"
                      getParamsFunc={getExportParams}
                      requestMethod="GET"
                      permissionKey="/car-admin/service-task-dispose/export"
                    />
                    <PermissionButton
                      operateType="/car-admin/car-diagnosis/service-recoed/add-batch"
                      type="primary"
                      onClick={addserviceRecodeBatch}
                    >
                      批量新增客服记录
                    </PermissionButton>
                    <PermissionButton
                      operateType="/car-admin/car-diagnosis/service-recoed/work-order"
                      type="primary"
                      onClick={distributeBatch}
                      style={{ margin: "0 0px 0px 8px" }}
                    >
                      批量建工单
                    </PermissionButton>
                    <PermissionButton
                      operateType="/car-admin/service-task-dispose/batch-assign"
                      type="primary"
                      onClick={handleBatchAssign}
                      style={{ margin: "0 0px 0px 8px" }}
                    >
                      批量分配客服
                    </PermissionButton>
                    <Button
                      type="primary"
                      onClick={openDispatchAgentModal}
                      disabled={agentTaskPool.length === 0}
                      style={{ margin: "0 0px 0px 8px" }}
                    >
                      派发智能体任务
                    </Button>
                  </div>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Collapse.Panel>
      </Collapse>
      {/* 任务池 */}
      <div style={{ margin: '16px 0', padding: '12px 16px', background: '#fafafa', borderRadius: '4px', border: '1px solid #f0f0f0' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
          <div style={{ fontWeight: 500, fontSize: 14 }}>任务池</div>
          <div style={{ display: 'flex', gap: 8 }}>
            <Button
              type="primary"
              size="small"
              onClick={handleAddToAgentTask}
              disabled={selectedRowKeys.length === 0}
            >
              添加
            </Button>
            <Button
              type="default"
              size="small"
              onClick={() => setAgentTaskPool([])}
              disabled={agentTaskPool.length === 0}
            >
              清空
            </Button>
          </div>
        </div>
        {agentTaskPool.length === 0 ? (
          <span style={{ color: "#999" }}>暂无任务</span>
        ) : (
          <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
            {agentTaskPool.map((item, index) => (
              <Tag
                key={item.id}
                closable
                onClose={() => handleRemoveFromAgentTask(item.id)}
                style={{ marginBottom: 8 }}
              >
                {index + 1}-{item.plateNumber}-{item.deviceTypeStr || "-"}-
                {item.type || "-"}
              </Tag>
            ))}
          </div>
        )}
      </div>
      <CommonTable
        rowKey="id"
        columns={columns}
        dataSource={data}
        pagination={{
          total: totalCount,
          current: page,
          pageSize: limit,
          onChange: onPageChange,
        }}
        bordered
        loading={loading}
        rowSelection={rowSelection}
        scroll={{ y: "100%" }}
      />
      {/* 创建工单的弹窗 */}
      {[
        "add",
        "edit",
        "servicrAdd",
        "servicrTaskAdd",
        "servicBatchDispatchOrder",
      ].includes(addWorkOrder?.type) && (
          <OperateModal
            type={addWorkOrder.type}
            workOrderInfo={addWorkOrder.data}
            onClose={() => setAddWorkOrder({})}
            reloadData={() => getData()}
            workId={getWorkOrderId}
          />
        )}
      {/* 评论 */}
      {operateInfo?.type === "detail" && (
        <TaskDetail
          item={operateInfo.data}
          onClose={() => taskCommentDetail()}
        />
      )}
      {/* 添加客服记录的弹窗 */}
      {operateVisible.show && (
        <OperateService
          type={operateVisible.type}
          onClose={() => setOperateVisible({ show: false, type: "add" })}
          reloadData={() => getData()}
          data={operateVisible.data}
          anyData={anyData}
        />
      )}
      {/* 历史联系结果 */}
      {operateInfo.type === "history" && (
        <HistoryResult
          data={operateInfo.data}
          closeModal={() => setOperateInfo({})}
        />
      )}
      {/* 客服记录 */}
      {operateInfo.type === "record" && (
        <AllServiceRecord
          data={operateInfo.data}
          closeModal={() => setOperateInfo({})}
        />
      )}
      {/* 添加退回原因（即留言） */}
      {operateInfo?.type === "sendback" && (
        <SendBackCause
          id={operateInfo.data}
          onClose={() => setOperateInfo({})}
          reloadData={getData}
        />
      )}
      {/* 批量分配客服弹窗 */}
      <Modal
        title="批量分配客服"
        open={batchAssignVisible}
        onOk={handleBatchAssignSubmit}
        onCancel={() => setBatchAssignVisible(false)}
        confirmLoading={batchAssignLoading}
        destroyOnClose
      >
        <div style={{ padding: "20px 0" }}>
          <span style={{ marginRight: 8 }}>客服人员：</span>
          <Select
            placeholder="请选择客服"
            options={userData}
            allowClear
            showSearch
            fieldNames={{
              label: 'nickname',
              value: 'id'
            }}
            optionFilterProp="nickname"
            style={{ width: 300 }}
            value={batchAssignCustomerId}
            onChange={(val) => setBatchAssignCustomerId(val)}
          />
        </div>
      </Modal>
      {/* 派发智能体任务弹窗 */}
      <Modal
        title="派发智能体任务"
        open={dispatchAgentVisible}
        onOk={handleDispatchAgentTask}
        onCancel={() => setDispatchAgentVisible(false)}
        confirmLoading={dispatchAgentLoading}
        okText="确认派发"
        cancelText="取消"
        destroyOnClose
      >
        <div style={{ padding: "20px 0" }}>
          <span style={{ marginRight: 8 }}>智能体：</span>
          <Select
            placeholder="请选择智能体"
            options={agentOptions}
            allowClear
            showSearch
            fieldNames={{ label: "name", value: "id" }}
            optionFilterProp="name"
            style={{ width: 300 }}
            value={dispatchAgentId}
            onChange={(val) => setDispatchAgentId(val)}
          />
        </div>
      </Modal>
    </Card>
  );
};

export default ServiceTaskDispose;
